import React from 'react';
import PropTypes from 'prop-types';

const MailClient = ({ className }) => (
  <svg
    viewBox="0 0 470 409"
    preserveAspectRatio="xMinYMin slice"
    className={className}
  >
    <defs>
      <pattern
        id="mailclient-pattern"
        patternUnits="objectBoundingBox"
        y="-16.966967%"
        height="116.966967%"
        width="100%"
      >
        <use transform="scale(0.232291667,0.232291667)" />
      </pattern>
    </defs>
    <rect fill="#E8EBED" x="0" y="0" width="470" height="410" />
    <rect fill="#E8EBED" x="0" y="0" width="470" height="310" />
    <circle fill="#BABCBF" cx="29" cy="16" r="4" />
    <circle fill="#BABCBF" cx="40" cy="16" r="4" />
    <circle fill="#BABCBF" cx="51" cy="16" r="4" />
  </svg>
);

MailClient.propTypes = {
  className: PropTypes.string,
};

export default MailClient;
